import { cubeGeometry } from "../state/cubeGeometry";
import { Cube } from "../state/types";

// De body voor POST /api/projects/<id>/parcels.
export const parcelPayload = (field: Cube) => ({
  name: field.name,
  geometry: cubeGeometry(field),
  center: { type: "Point", coordinates: field.center },
});
